import Icon from '../../components/Icon.vue'

Icon.register({"regular/bell-slash":{"width":640,"height":512,"paths":[{"d":"M634 471L36 3.5C29.1-2 19-0.9 13.5 6L3.5 18.5C-2 25.4-0.9 35.5 6 41L604 508.5C610.9 514 621 512.9 626.5 506L636.5 493.5C642 486.6 640.9 476.5 634 471zM163.5 368C180.2 346 198 312.2 204.9 257.4L159.5 221.9C156.2 312.6 123 342.6 104.6 362.3 98.6 368.7 96 376.4 96 384 96.1 400.4 109 416 128.1 416H407.8L346.4 368H163.5zM320 96C381.9 96 432 146.1 432 208 432 208.2 431.9 208.4 431.9 208.6 432 225.4 433.1 240.3 434.7 254.3L494.3 300.9C485.9 278.7 479.9 249.4 479.9 208 479.9 130.3 425.4 68.1 352 52.8V32C352 14.3 337.7 0 320 0S288 14.3 288 32V52.8C262 58.3 238.6 69.8 218.9 85.6L257.1 115.4C275 103.2 296.6 96 320 96zM320 512C355.3 512 384 483.4 384 448H256C256 483.4 284.7 512 320 512z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/bell-slash.js
// module id = null
// module chunks = 